'use strict';
import { module } from '../app';
import * as _ from 'lodash';

module
  .factory('surveyViewModel', [
    'Worklist', 'Diagram', '$filter', 'authService', '$sce', '$q', '$timeout', '$location', 'modalService', 'eventsMgr', '$ionicLoading', 'serverTimeService', 'techpadConfig', 'Study', 'documentsSvc', '$rootScope', 'dataRetrieverService', 'enums',
    function (Worklist, Diagram, $filter, authService, $sce, $q, $timeout, $location, modalService, eventsMgr, $ionicLoading, serverTimeService, techpadConfig, Study, documentsSvc, $rootScope, dataRetrieverService, enums) {
      let vm = function (patient, isViewOnly, changeTab, markSurveyAsReviewedCallback, worklistId) {
        let self = this;
        self.statuses = enums.statuses;

        self.initSurvey = function () {
          // survey not started yet
          self.isSurveyStatus = patient.Status == 'New' || patient.Status == 'SurveyStarted';

          // worklist went to ExamWaiting status without Survey
          self.isSurveySkipped = !self.isSurveyStatus && !patient.SurveyLogId;

          // show checkmark at top menu if survey skipped or already reviewed
          self.isHistoryTabViewed = self.isSurveySkipped || patient.SurveyReviewed;

          // close iframe
          self.editMode = false;

          // Case: Survey is skipped on linked
          if (patient.Study.IsLinked) {
            // do not load info
            return;
          }

          // Case: View only mode
          if (isViewOnly && !self.isSurveySkipped) {
            // load existing answers
            self.loadSurveyInfo();
            return;
          }

          // Case: Survey is not passed yet
          if (self.isSurveyStatus || self.isSurveySkipped) {
            // 1. go to History tab and lock tab
            // 2. generate pin number and preload survey iframe

            changeTab(techpadConfig.settings.DefaultWorklistTab);

            self.validPinNumber = false;

            let pinNumberObject = _.find($rootScope.pinNumbers, {
              'Ssn': patient.Ssn,
              'SDate': patient.Study.SDate
            });
            self.surveyPinNumber = pinNumberObject ? pinNumberObject.PinNumber : null;
            if (!self.surveyPinNumber) {
              self.generatePinNumber(patient.Ssn, patient.Study.SDate);
            } else {
              Study.checkPinNumber(self.surveyPinNumber).then(function (resp) {
                if (!resp.data.IsValid) {
                  self.generatePinNumber(patient.Ssn, patient.Study.SDate);
                } else {
                  self.validPinNumber = true;
                }
              });
            }
            return;
          }

          // Case: Survey is finished but not reviewed
          if (!self.isSurveyStatus && !patient.SurveyReviewed && !self.isSurveySkipped) {
            // load answers from SurveyLog
            // go to History tab
            self.loadSurveyInfo();
            changeTab(10);
            return;
          }

          // Case: Survey is finished and reviewed
          if (!self.isSurveyStatus && !self.isSurveySkipped) {
            // load answers from SurveyLog
            self.loadSurveyInfo();
            return;
          }
        };

        self.generatePinNumber = function (ssn, sdate) {
          Study.generatePinNumber(ssn, sdate).then(function (r) {
            self.surveyPinNumber = r.data;
            if (!$rootScope.pinNumbers) {
              $rootScope.pinNumbers = [];
            }
            $rootScope.pinNumbers.push({
              'Ssn': ssn,
              'SDate': sdate,
              'PinNumber': self.surveyPinNumber
            });
            if (!self.isSurveySkipped) {
              self.loadSurveyInfo();
            }
            self.validPinNumber = true;
          });
        };

        self.formatAnswer = function (qa) {

          var answer = qa.InitialAnswer;

          if (!answer) {
            return '-';
          }
          if (answer.declined) {
            return 'Declined';
          } else {
            return answer.formattedAnswer /*|| answer.value*/ || '-';
          }
        };

        self.getHighlightColor = function (qa) {
          // highlight on summary after submit
          if (!qa.Code && qa.Question.highlightOnSummaryIfValueIs && qa.Answer.value == qa.Question.highlightOnSummaryIfValueIs) {
            return qa.Question.highlightColor ? qa.Question.highlightColor : '#FFFF72';
          } else {
            return '';
          }
        };

        self.loadSurveyInfo = function (pinNumber) {
          if (self.isSurveyStatus) {
            // use pin
          } else {
            $ionicLoading.show({
              template: 'Loading survey information...'
            });
            dataRetrieverService.cachedProxy('worklist-patient-survey-' + patient.Id, 0, function () {
              return Study.getSurveyLog(patient.SurveyLogId)
            })
              .then(function (resp) {
                $ionicLoading.hide();
                self.surveyInfo = resp.data;
                self.surveyInfo.Questions = _.map(self.surveyInfo.Questions, function (question) {
                  let model = question;
                  model.IsHidden = question.IsHiddenQuestion || question.Type == 'idverification' || question.Type == 'Summary';
                  return model;
                });
              }, function (resp) {
                $ionicLoading.hide();
                modalService.showErrorMessage(resp.data, resp.status);
              });
          }
        };

        self.checkIfActionCanBePerformed = async function (worklistId, hideAlert) {
          let studyLocked = await Worklist.checkStudyLock(worklistId);
          if (studyLocked.data.IsLock) {
            if (!hideAlert) {
              modalService.showAlert(`This exam is now taken by ${studyLocked.data.CurrentUser.UserName}. You cannot perform this action`);
            }
            return false;
          }
          return true;
        };

        self.markSurveyAsReviewed = async function () {
          if (!(await self.checkIfActionCanBePerformed(worklistId))) {
            return;
          }
          Study.reviewSurvey(patient.SurveyLogId).then(function () {
            self.isHistoryTabViewed = true;
            markSurveyAsReviewedCallback();

            /*patient.SurveyReviewed = true;
             if (techpadConfig.settings.HideStartAndEndButtons) {
             patient.JustReviewed = true;
             patient.Status = self.statuses[4];
             Worklist.updateStatus(patient.Id, enums.worklistStatuses.ExamInProgress).then(function(){
             changeTab(1);
             markSurveyAsReviewedCallback();
             return;
             });
             }else{
             Worklist.updateStatus(patient.Id, enums.worklistStatuses.ExamWaiting).then(function(){
             changeTab(1);
             markSurveyAsReviewedCallback();
             });
             } */
          });
        };

        self.surveyLoaded = function () {
          self.isSurveyLoaded = true;
          if (self.timeout) {
            $timeout.cancel(self.timeout);
          }
          return $ionicLoading.hide();
        };

        self.startSurvey = function () {
          Study.checkPinNumber(self.surveyPinNumber).then(function (resp) {
            if (!resp.data.Success) {
              let message = '';
              if (!resp.data.IsExist) {
                message = 'Pin number does not exist. ';
              } else if (resp.data.IsExpired) {
                message = 'Pin number is expired. ';
              }
              modalService.showAlert('Invalid PIN number. ' + message + 'Please reload the page to generate a new one.');
              return;
            } else {
              if (self.isSurveyStatus || self.isSurveySkipped) {
                self.editMode = true;
                self.isSurveySkipped = false;
                Study.generateSurveySecureKey(self.surveyPinNumber).then(function (resp) {
                  self.portalUrl = $sce.trustAsResourceUrl(authService.currentMagViewUrl() + '/survey' + '?pin=' + self.surveyPinNumber + '&mode=techpad&key=' + resp.data);
                });
              }
              self.modifySurvey();
            }
          });
        };

        self.skipSurvey = function () {
          console.log('skip survey function');
        };

        self.modifySurvey = async function () {
          if (!(await self.checkIfActionCanBePerformed(patient.Id))) {
            return;
          }
          Worklist.historyChangedInMagview(patient.Id).then(function (resp) {
            let lastChangeFromMagview = resp.data.historyChangedInMagview;
            if (lastChangeFromMagview && (patient.IsReviewedFirstTime || patient.SurveyHistoryFromTechpad)) {
              modalService.showAlert('This study has been modified in MagView. All history changes must now be done in MagView.');
              return;
            }
            /*if (self.isSurveyLoaded) {
              self.editMode = true;
              return;
            }*/
            if (patient.SurveyLogId) {
              authService.getPortalSecurityToken().then(function (resp) {
                self.portalUrl = $sce.trustAsResourceUrl(authService.currentMagViewUrl() + '/survey/techpadReview/' + patient.SurveyLogId + '?token=' + resp.data);
                self.continueModifySurvey();
              });
            } else {
              self.continueModifySurvey();
            }
          });
        };

        self.continueModifySurvey = function () {
          self.editMode = true;
          $ionicLoading.show({ template: 'Loading...' });
        };

        self.openHistoryInBrowser = function () {
          window.open(self.portalUrl, '_system', 'location=no');
        };
      };

      return vm;
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/models/survey.js